import { createSlice } from "@reduxjs/toolkit";
import { ApplicantType } from "utils/Types";

type ApplicantProfileSliceType = {
  data: ApplicantType;
};

const ApplicantProfileInit: ApplicantProfileSliceType = {
  data: {} as ApplicantProfileSliceType["data"]
};

export const ApplicantProfileSlice = createSlice({
  name: "applicant",
  initialState: ApplicantProfileInit,
  reducers: {
    updateApplicantProfile: (state, action) => {
      state.data = action.payload;
    }
  }
});

export const { updateApplicantProfile } = ApplicantProfileSlice.actions;

export default ApplicantProfileSlice.reducer;
